import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';
import { useRouter } from 'next/compat/router';

import useTranslation from 'hooks/use-translation';

import ChevronIcon from 'assets/chevron-icon';
import { Link, ModalContainer } from 'components/core';
import usePaths from 'hooks/use-paths';

import DispensaryChainCard from './dispensary-chain-card';

const DispensaryChainResult = forwardRef(
  ({ nearestDispensaryLocation, onClearAddress, containerProps, loading }, ref) => {
    const { t, Trans } = useTranslation();
    const router = useRouter();
    const { asPath } = router;
    const { href, route } = usePaths({ locations: true, browse: true });

    return (
      <ModalContainer width={520} ref={ref} {...containerProps}>
        {/* eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions */}
        <BackArrowContainer onClick={onClearAddress}>
          <BackArrow />
        </BackArrowContainer>

        <NearestLocation mb='20px'>{t('chain.nearestLocation', 'Our Nearest Location')}</NearestLocation>
        {!nearestDispensaryLocation && !loading && (
          <SorryText my='10px'>
            <Trans i18nKey='chain.sorry'>We're sorry, we were unable to find any nearby locations!</Trans>
          </SorryText>
        )}
        {(nearestDispensaryLocation || loading) && (
          <DispensaryChainCard dispensary={nearestDispensaryLocation} loading={loading} />
        )}
        <Link href={href} route={route} query={{ backTo: asPath }}>
          {/* eslint-disable-next-line styled-components-a11y/anchor-is-valid */}
          <BrowseLocationsLink>{t('chain.browse', 'Browse all locations')}</BrowseLocationsLink>
        </Link>
      </ModalContainer>
    );
  }
);

export default DispensaryChainResult;

const NearestLocation = styled.div`
  color: var(--dcm-locations-heading-color);
  font-size: 21px;
  font-weight: bold;

  ${space}
`;

const SorryText = styled.div`
  color: var(--dcm-locations-text-color);
  font-size: 14px;
  padding: 20px;
`;

const BackArrow = styled(ChevronIcon)`
  fill: var(--dcm-locations-link-color);
  transform: rotate(90deg);
  height: 8px;
  margin-right: 5px;
  cursor: pointer;
`;

const BackArrowContainer = styled.div`
  padding-left: 10px;
  position: absolute;
`;

const BrowseLocationsLink = styled.a`
  color: var(--dcm-locations-link-color);
  font-size: 12px;
  margin-top: 30px;
`;
